<template>
  <v-app id="app">
    <root-layout>
      <v-main>
        <!-- <v-slide-y-transition> -->
          <router-view v-if="appStatus" />
          <v-container style="height:100vh;flex-direction:column" class="d-flex justify-center align-center" v-else>
            <h1 class="primary--text">Dtunes Admin will be back up soon</h1>
            <br>
            <h1>😊😊😊</h1>
          </v-container>
        <!-- </v-slide-y-transition> -->
      </v-main>
    </root-layout>
  </v-app>
</template>

<script>
import update from './mixins/update';
import RootLayout from "./layouts/root-layout.vue";

export default {
  name: "App",

  data: () => ({
    appStatus : true
    //
  }),
  mixins:[update],

  async mounted(){

  },
  method:{
   
  },
  components: {
    RootLayout,
  },
};
</script>

<style lang="scss">
html {
  overflow-y: auto !important;
}
</style>
